import * as requestFromServer from "./authCrud";
import { Slice, callTypes, setUsers } from "./authSlice";
const { actions } = Slice;


export const addQuestions = (data, setAlertField) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .questionAdd(data)
    .then((response) => {
      if (response.data.success) {
        setAlertField({
          title: "Success",
          text: "",
          show: true,
          color: "green",
        });
      } else {
        setAlertField({
          title: "Error",
          text: response.data.message,
          show: true,
          color: "red",
        });
      }
      return response.data.message;
    })
    .catch((error) => {
      console.error("addQuestions error:", error);
      const errMsg =
        error?.response?.data?.message || error?.message || "Bilinmeyen hata.";
      setAlertField({
        title: "Error",
        text: errMsg,
        show: true,
        color: "red",
      });
    });
};

export const userStoreIdentitiyAction = (data) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .userIdentityAction(data)
    .then((response) => {
      if (response.data.success) {
        localStorage.setItem("token", response.data.data.token);
        return response.data;
      } else {
        return response.data;
      }
    })
    .catch((error) => {
      console.error("userStoreIdentitiyAction error:", error);
    });
};


export const userLogin = (data) => (dispatch) => {
  return requestFromServer
    .login(data)
    .then((response) => {
      if (response.status === 200 && response.data.token) {
        dispatch(actions.login(response.data.user));
        dispatch(actions.setToken(response.data.token));
        localStorage.setItem("token", response.data.token); 
        return true;
      } else {
        return false;
      }
    })
    .catch((error) => {
      console.error("userLogin error:", error);
      const errMsg =
        error?.response?.data?.message || error.message || "Sunucu hatası.";
      dispatch(actions.catchError({ err: errMsg, callType: callTypes.list }));
      return false;
    });
};


export const userUpdate = (id) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .getUpdatedUser(id)
    .then((response) => {
      dispatch(actions.updatedUser(response.data));
      return response.data;
    })
    .catch((error) => {
      console.error("userUpdate error:", error);
      const errMsg =
        error?.response?.data?.message || error?.message || "Sunucu hatası.";
      dispatch(actions.catchError({ err: errMsg, callType: callTypes.list }));
      return false;
    });
};


export const userRegister = (data) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .register(data)
    .then((response) => {
      dispatch(actions.registerUser(response.data));
      return response.data;
    })
    .catch((error) => {
      console.error("userRegister error:", error);
      const errMsg =
        error?.response?.data?.message || error?.message || "Sunucu hatası.";
      dispatch(actions.catchError({ err: errMsg, callType: callTypes.list }));
      return false;
    });
};


export const userLogout = () => (dispatch) => {
  try {
   
    localStorage.removeItem("token");
    localStorage.removeItem("persist:root");

    
    dispatch(actions.logOut());
    dispatch(actions.setToken(null));

   
    window.location.href = "/auth"; 

    return true;
  } catch (error) {
    console.error("userLogout error:", error);
    const errMsg =
      error?.response?.data?.message || error?.message || "Sunucu hatası.";
    dispatch(actions.catchError({ err: errMsg, callType: callTypes.list }));
    return false;
  }
};

export const getUsers = () => async (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  try {
    const response = await requestFromServer.getUsers();
    if (response.data) {
       dispatch(setUsers(response.data.users)); // actions. yerine direkt setUsers
    }
    return response.data;
  } catch (error) {
    console.error("getUsers error:", error);
    const errMsg = error?.response?.data?.message || error?.message || "Sunucu hatası.";
    dispatch(actions.catchError({ err: errMsg, callType: callTypes.list }));
    return false;
  }
};

export const getInfos = () => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .getInfos()
    .then((response) => {
      dispatch(actions.getInfos(response.data));
      return response.data;
    })
    .catch((error) => {
      console.error("getInfos error:", error);
      const errMsg =
        error?.response?.data?.message || error?.message || "Sunucu hatası.";
      dispatch(actions.catchError({ err: errMsg, callType: callTypes.list }));
      return false;
    });
};


export const setLoginUser = (userData) => (dispatch) => {
  dispatch(actions.login(userData));
};

export const resetPassword = (data) => async (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  try {
    const response = await requestFromServer.resetPassword(data);
    if (response.status === 200 || response.status === 201 || (response.data && response.data.success)) {
      // Başarılı mesajı göstermek için
      return { success: true, message: response.data.message || response.data.msg || "Şifre başarıyla güncellendi." };
    } else {
      const errorMsg = response.data?.message || response.data?.msg || "Şifre güncellenemedi.";
      dispatch(actions.catchError({ err: errorMsg, callType: callTypes.list }));
      return { success: false, message: errorMsg };
    }
  } catch (error) {
    console.error("resetPassword error:", error);
    const errMsg = error?.response?.data?.message || error?.response?.data?.msg || error.message || "Sunucu hatası.";
    dispatch(actions.catchError({ err: errMsg, callType: callTypes.list }));
    return { success: false, message: errMsg };
  }
};

export const getSettingsAction = () => async () => {
  try {
    const response = await requestFromServer.getSystemSettings();
    return response.data;
  } catch (error) {
    console.error("getSettingsAction error:", error);
    return null;
  }
};

export const updateSettingsAction = (data) => async () => {
  try {
    const response = await requestFromServer.updateSystemSettings(data);
    return response.data;
  } catch (error) {
    console.error("updateSettingsAction error:", error);
    return null;
  }
};
